var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kv-tooltip',{attrs:{"text":_vm.tooltipText,"disabled":!_vm.showTooltip}},[_c('span',{staticClass:"invoice-status-badge",class:_vm.statusClass},[_vm._v("\n        "+_vm._s(_vm.statusLabel)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }